import { render, staticRenderFns } from "./TaskRequestDialogClose.vue?vue&type=template&id=54f4039d"
import script from "./TaskRequestDialogClose.vue?vue&type=script&lang=js"
export * from "./TaskRequestDialogClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports